// global
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// components
import DefaultButton from 'app/components/commons/button/defaultButton/DefaultButton';
// icons
import IndicatorIcon from 'assets/icon/indicator-icon/IndicatorIcon';
// const
import { COLORS } from 'app/config/colors';
// stylesheet
import styles from './FixateMenuButton.module.scss';

function FixateMenuButton(props) {
  return (
    <div className={styles.fixateMenuButton}>
      <DefaultButton
        onClick={props.handleState}
        tag=''
        size='medium'
        icon={
          <IndicatorIcon
            direction={props.menuState.fixed ? 'left' : 'right'}
            fill={COLORS.ACCENTUATED_VARIANT}
          />
        }
        iconHover={
          <IndicatorIcon
            direction={props.menuState.fixed ? 'left' : 'right'}
            fill={COLORS.ACCENTUATED_VARIANT}
          />
        }
        color={COLORS.ACCENTUATED_VARIANT}
        colorHover={COLORS.ACCENTUATED_VARIANT}
        backgroundColor={COLORS.WHITE_VARIANT}
        backgroundColorHover={COLORS.WHITE_VARIANT}
        borderColor={COLORS.ACCENTUATED_VARIANT}
        borderColorHover={COLORS.ACCENTUATED_VARIANT}
      />
    </div>
  );
}

FixateMenuButton.defaultProps = {
  handleState: () => {}
};

FixateMenuButton.propTypes = {
  menuState: PropTypes.object,
  handleState: PropTypes.func
};

const mapStateToProps = state => ({
  close: state.close,
  fixed: state.fixed
});

export default connect(mapStateToProps)(FixateMenuButton);
